import clsx from 'clsx'; // npm i clsx
import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useLogin } from '@/features/auth/hooks/useLogin';

export const LoginPage = () => {
    const navigate = useNavigate();
    const { login, loading, error } = useLogin();

    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [showPassword, setShowPassword] = useState(false);
    const [touched, setTouched] = useState({ email: false, password: false });

    const handleSubmit = async (e: React.FormEvent) => {
        e.preventDefault();
        setTouched({ email: true, password: true });

        if (!email || !password) return;

        const success = await login(email, password);
        if (success) navigate('/checkup');
    };

    const isEmailInvalid = touched.email && !email;
    const isPasswordInvalid = touched.password && !password;

    return (
        <main className="layout__content">
            <section className="section layout__section auth">
                <div className="container">
                    <div className="auth__block auth-block">
                        <header className="auth-block__header">
                            <h1 className="title auth-block__title">Вход</h1>
                        </header>

                        <div className="auth-block__content">
                            <form className="form auth__form auth-form" onSubmit={handleSubmit} noValidate>
                                {error && (
                                    <div style={{ color: '#EA3323', marginBottom: '1rem', fontWeight: 500 }}>
                                        Неверный логин или пароль!
                                    </div>
                                )}

                                <fieldset className="auth-form__fields">
                                    <div className="form__row">
                                        <div className="input">
                                            <label htmlFor="email" className="input__label input-label">E-Mail</label>
                                            <label className={clsx("text-input", {
                                                'text-input--error': isEmailInvalid
                                            })}>
                                                <input
                                                    id="email"
                                                    className="text-input__input"
                                                    placeholder={isEmailInvalid ? 'Введите ваш email' : 'example@gmail.com'}
                                                    type="email"
                                                    value={email}
                                                    onChange={(e) => setEmail(e.target.value)}
                                                    onBlur={() => setTouched(prev => ({ ...prev, email: true }))}
                                                    required
                                                />
                                            </label>
                                        </div>
                                    </div>

                                    <div className="form__row">
                                        <div className="input">
                                            <label htmlFor="password" className="input__label input-label">Пароль</label>
                                            <label className={clsx("text-input", {
                                                'text-input--error': isPasswordInvalid
                                            })}>
                                                <input
                                                    id="password"
                                                    className={"text-input__input"}
                                                    placeholder={isPasswordInvalid ? 'Введите ваш пароль' : 'Введите пароль'}
                                                    type={showPassword ? 'text' : 'password'}
                                                    value={password}
                                                    onChange={(e) => setPassword(e.target.value)}
                                                    onBlur={() => setTouched(prev => ({ ...prev, password: true }))}
                                                    required
                                                />
                                                <div className="text-input__control">
                                                    <button
                                                        type="button"
                                                        onClick={() => setShowPassword(p => !p)}
                                                        className="text-input__icon text-input__password-toggle"
                                                    >
                                                        <svg className="svg-icon">
                                                            <use
                                                                href={`${showPassword ? '/img/sprite-icons.svg#eye-slash-fill' : '/img/sprite-icons.svg#eye-fill'}`} />
                                                        </svg>
                                                    </button>
                                                </div>
                                            </label>
                                        </div>
                                    </div>
                                </fieldset>

                                <fieldset className="auth-form__hint">
                                    <a className="form__link" href="/password-reset">Забыли пароль?</a>
                                </fieldset>

                                <fieldset className="auth-form__submit">
                                    <p className="auth-form__submit-text">
                                        Нажимая кнопку &laquo;Войти&raquo;, вы принимаете{' '}
                                        <a className="form__link" href="/politika-konfidenczialnosti">политику
                                            конфиденциальности</a>{' '}
                                        и <a className="form__link" href="/personal-data">соглашение об обработке данных</a>
                                    </p>
                                    <button
                                        type="submit"
                                        className="button button_outline button_block auth-form__submit-button"
                                        disabled={loading}
                                    >
                                        {loading ? 'Вход...' : 'Войти'}
                                    </button>
                                </fieldset>

                                <div className="auth-form__divider">
                                    <hr className="auth-form__divider-line" />
                                    <span className="auth-form__divider-text">или</span>
                                    <hr className="auth-form__divider-line" />
                                </div>

                                <fieldset className="auth-form__hint">
                                    <span className="auth-form__hint-text">Еще не зарегистрированы?</span>{' '}
                                    <a className="form__link" href="/registration">Регистрация</a>
                                </fieldset>
                            </form>
                        </div>
                    </div>
                </div>
            </section>
        </main>
    );
};
